import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { parse } from '../../util/urlHelpers';
import config from '../../config';

const CONSOLE_PAGE_SIZE = 100;

// ================ Async Thunks ================ //

export const loadData = createAsyncThunk(
  'catalog/fetchList',
  async ({ params, search }, { dispatch, rejectWithValue, extra: sdk }) => {
    try {
      const { page = 1, countryId = config.custom.countryId, phrase, businessCategory } = parse(search);
      const queryParams = {
        page,
        per_page: CONSOLE_PAGE_SIZE,
        include: ['images', 'catalogItems.images'],
        countryId,
        ...(businessCategory ? { businessCategory } : {}),
        ...(phrase ? { phrase } : {}),
      };

      const response = await sdk.newSdk.catalogProducts.query(queryParams);

      dispatch(addMarketplaceEntities(response));

      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

// ================ Slice (Reducer + Action Creators w jednym) ================ //

const initialState = {
  fetchInProgress: false,
  fetchProductCatalogListError: null,
  pagination: null,
  productCatalogList: [],
  newlyCreatedProductId: null,
};

const consoleProductCatalogSlice = createSlice({
  name: 'consoleProductCatalog',
  initialState,
  reducers: {
    prependNewProduct: (state, action) => {
      const newProductRef = action.payload; 
      state.newlyCreatedProductId = newProductRef.id.uuid;

      const exists = state.productCatalogList.some(
        item => item.id.uuid === newProductRef.id.uuid
      );

      if (!exists) {
        state.productCatalogList = [newProductRef, ...state.productCatalogList];
        if (state.pagination) {
          state.pagination.totalItems += 1;
        }
      }
    },

    clearNewlyCreatedProduct: (state) => {
      state.newlyCreatedProductId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadData.pending, (state, action) => {
        state.fetchInProgress = true;
        state.fetchProductCatalogListError = null;
        const { page = 1 } = parse(action.meta.arg.search);
  
        if (Number(page) !== 1) {
          state.newlyCreatedProductId = null;
        }
      })
      .addCase(loadData.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        let fetchedList = action.payload.data.data;
        const { page = 1 } = parse(action.meta.arg.search);

        if (Number(page) === 1 && state.newlyCreatedProductId) {
          const newId = state.newlyCreatedProductId;
          const filteredList = fetchedList.filter(item => item.id.uuid !== newId);
          fetchedList = [{ id: { uuid: newId }, type: 'catalog-product' }, ...filteredList];
        }

        state.productCatalogList = fetchedList;
        state.pagination = action.payload.data.meta;
      })
      .addCase(loadData.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchProductCatalogListError = action.payload;
        console.error(action.payload);
      });
  },
});

export const { prependNewProduct, clearNewlyCreatedProduct } = consoleProductCatalogSlice.actions;
export default consoleProductCatalogSlice.reducer;